import {
  onboardingFeatureDisplayNames,
  onboardingFeatures,
  signupUseCases,
} from 'client/GrowthEngineering/utilities/GrowthConstants';

// The feature arrays are in logical ordering
export const marketingUseCases = [
  {
    features: [
      { name: onboardingFeatureDisplayNames.appleMdm, value: onboardingFeatures.appleMdm },
      {
        name: onboardingFeatureDisplayNames.userManagement,
        value: onboardingFeatures.userManagement,
      },
      { name: onboardingFeatureDisplayNames.radius, value: onboardingFeatures.radius },
      {
        name: onboardingFeatureDisplayNames.passwordManagement,
        value: onboardingFeatures.passwordManagement,
      },
      { name: onboardingFeatureDisplayNames.remoteAssist, value: onboardingFeatures.remoteAssist },
      { name: onboardingFeatureDisplayNames.ssoAuth, value: onboardingFeatures.ssoAuth },
      {
        name: onboardingFeatureDisplayNames.deviceManagement,
        value: onboardingFeatures.deviceManagement,
      },
      { name: onboardingFeatureDisplayNames.ldap, value: onboardingFeatures.ldap },
    ],
    icon: 'applications',
    label: signupUseCases.consolidatingITStack,
  },
  {
    features: [
      { name: onboardingFeatureDisplayNames.appleMdm, value: onboardingFeatures.appleMdm },
      {
        name: onboardingFeatureDisplayNames.userManagement,
        value: onboardingFeatures.userManagement,
      },
      { name: onboardingFeatureDisplayNames.radius, value: onboardingFeatures.radius },
      {
        name: onboardingFeatureDisplayNames.passwordManagement,
        value: onboardingFeatures.passwordManagement,
      },
      { name: onboardingFeatureDisplayNames.remoteAssist, value: onboardingFeatures.remoteAssist },
      { name: onboardingFeatureDisplayNames.ssoAuth, value: onboardingFeatures.ssoAuth },
      {
        name: onboardingFeatureDisplayNames.deviceManagement,
        value: onboardingFeatures.deviceManagement,
      },
      {
        name: onboardingFeatureDisplayNames.serverManagement,
        value: onboardingFeatures.serverManagement,
      },
    ],
    icon: 'devices',
    label: signupUseCases.enablingHybrid,
  },
  {
    features: [
      { name: onboardingFeatureDisplayNames.compliance, value: onboardingFeatures.compliance },
      {
        name: onboardingFeatureDisplayNames.userManagement,
        value: onboardingFeatures.userManagement,
      },
      {
        name: onboardingFeatureDisplayNames.passwordManagement,
        value: onboardingFeatures.passwordManagement,
      },
      {
        name: onboardingFeatureDisplayNames.deviceManagement,
        value: onboardingFeatures.deviceManagement,
      },
      { name: onboardingFeatureDisplayNames.mfa, value: onboardingFeatures.mfa },
    ],
    icon: 'locked',
    label: signupUseCases.improvingSecurity,
  },
  {
    features: [
      { name: onboardingFeatureDisplayNames.compliance, value: onboardingFeatures.compliance },
      {
        name: onboardingFeatureDisplayNames.userManagement,
        value: onboardingFeatures.userManagement,
      },
      {
        name: onboardingFeatureDisplayNames.passwordManagement,
        value: onboardingFeatures.passwordManagement,
      },
      {
        name: onboardingFeatureDisplayNames.deviceManagement,
        value: onboardingFeatures.deviceManagement,
      },
      { name: onboardingFeatureDisplayNames.mfa, value: onboardingFeatures.mfa },
      { name: onboardingFeatureDisplayNames.radius, value: onboardingFeatures.radius },
    ],
    icon: 'directoryInsights',
    label: signupUseCases.meetingCompliance,
  },
];

export default {
  marketingUseCases,
};
